export default[
    {
        path: '/dataList/attendancePunch',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '开单打卡',
            authLogin: true
        }
    }
]